export default __webpack_public_path__ + "static/media/trr-food-handheld-chickencaesarwrap.cc152168.png";